module.exports = __webpack_public_path__ + "static/future-ai-img-2-ffec061a07af8cbf05695dfc6be068fb.png";